import axios from "axios";
const API_URL = 'https://media.filmwings.com/';

const CHUNK_SIZE = 1024 * 1024 * 2; // 2MB
const event_upload_url = API_URL + "event/upload_chunks";
const event_commit_url = API_URL + "event/commit_chunks";
const post_upload_url = API_URL + "posts/upload_chunks";
const post_commit_url = API_URL + "posts/commit_chunks";

const concurrency = 3;

/**
 * Web version of uploadChunks using File.slice()
 * @param {string|number} eventId 
 * @param {File} file (Standard browser File object)
 * @param {Function} onProgress 
 * @param {string} type 
 */
export const uploadChunksWeb = async (eventId, file, onProgress, type = 'event') => {
    const upload_url = type === 'adpost' ? post_upload_url : event_upload_url;
    const token = sessionStorage.getItem('LOGIN_TOKEN');

    const uploadId = 'upload_' + Date.now() + '_' + Math.random().toString(36).substring(7);
    const fileSize = file.size;

    const totalChunks = Math.ceil(fileSize / CHUNK_SIZE);
    console.log("Web Total Chunks: " + totalChunks);

    const queue = Array.from({ length: totalChunks }, (_, i) => i);
    let uploadedCount = 0;

    const worker = async () => {
        while (queue.length > 0) {
            const index = queue.shift();
            await uploadChunkWithRetryWeb(index, uploadId, file, fileSize, eventId, upload_url, token);

            uploadedCount++;
            const progress = (uploadedCount / totalChunks) * 100;
            if (onProgress) onProgress(progress);
            console.log(`Upload Progress: ${progress.toFixed(2)}%`);
        }
    };

    // Run parallel workers
    const workers = Array.from({ length: concurrency }, () => worker());
    await Promise.all(workers);

    return { uploadId, status: 'all', totalChunks, fileName: file.name };
};

const uploadChunkWithRetryWeb = async (index, uploadId, file, fileSize, eventId, upload_url, token) => {
    const start = index * CHUNK_SIZE;
    const end = Math.min(fileSize, start + CHUNK_SIZE);

    // Browser native chunk slicing
    const chunkBlob = file.slice(start, end);

    for (let attempt = 1; attempt <= 3; attempt++) {
        try {
            const formData = new FormData();
            formData.append('eventId', eventId);
            formData.append('uploadId', uploadId);
            formData.append('chunkIndex', index.toString());
            
            // Web Blob append matching backend 'file' field expectation
            formData.append('file', chunkBlob, `chunk_${index}`);

            await axios.post(upload_url, formData, {
                headers: {
                    'Authorization': token ? "Bearer " + token : "",
                    'Content-Type': 'multipart/form-data',
                    'Accept': 'application/json',
                }
            });

            return; // Exit retry loop on success
        } catch (error) {
            console.log(`[Attempt ${attempt}] Upload Error:`, error?.response?.data || error.message);
            if (attempt === 3) throw error;
            await new Promise(r => setTimeout(r, 1000 * attempt));
        }
    }
};

/**
 * Commit chunks call matching mobile behavior
 */
export const comitChunksWeb = async (comitData, type = 'event') => {
    const commit_url = type === 'adpost' ? post_commit_url : event_commit_url;
    const token = sessionStorage.getItem('LOGIN_TOKEN');

    for (let attempt = 1; attempt <= 3; attempt++) {
        try {
            const res = await axios.post(commit_url, comitData, {
                headers: {
                    'Authorization': token ? "Bearer " + token : "",
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }
            });
            return { eventId: comitData['eventId'], status: 'success', data: res.data };
        } catch (error) {
            if (attempt === 3) throw error;
            await new Promise(r => setTimeout(r, 1000 * attempt));
        }
    }
};